// This icon file is generated automatically.
var Drrp360TaskIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16.17 6.16a3.66 3.66 0 107.32 0 3.66 3.66 0 00-7.32 0zm6.12 5.28h-4.76c-1.61 0-3.06.59-4.08 1.52v9.44h3.58l.77 11.09h4.38l.74-11.09h3.63v-9.26a6.01 6.01 0 00-4.26-1.7zm3.27 15.33v1.93c4.05.6 6.84 1.85 6.84 3.29 0 2.03-5.55 3.67-12.4 3.67-6.85 0-12.4-1.64-12.4-3.67 0-1.45 2.8-2.7 6.9-3.3v-1.93c-6.79.74-11.68 2.8-11.68 5.22 0 3.05 7.7 5.52 17.18 5.52s17.18-2.47 17.18-5.51c0-2.42-4.87-4.47-11.62-5.22z", "fill-rule": "nonzero" } }] }, "name": "drrp-360task-icon", "theme": "outlined" };
export default Drrp360TaskIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/Drrp360TaskIconOutlined.js
// module id = 2491
// module chunks = 0